export const AlertSeverity = {
	ERROR: "error",
	WARNING: "warning",
	SUCCESS: "success",
	INFO: "info"
} as const;

type AlertSeverityType = (typeof AlertSeverity)[keyof typeof AlertSeverity];

export default class AlertMessage {
	readonly severity: AlertSeverityType;
	readonly message: string;

	private constructor(severity: AlertSeverityType, message: string) {
		this.severity = severity;
		this.message = message;
	}

	public static success(message: string) {
		return new AlertMessage(AlertSeverity.SUCCESS, message);
	}

	public static warning(message: string) {
		return new AlertMessage(AlertSeverity.WARNING, message);
	}

	public static error(message: string) {
		return new AlertMessage(AlertSeverity.ERROR, message);
	}

	public static info(message: string) {
		return new AlertMessage(AlertSeverity.INFO, message);
	}
}
